// CSS
import './SearchSuggestionInstance.css';
// Media assets
import trendingIcon from '../../../../assets/StandardIcons/ArrowIcons/trending-icon.webp';
import recentSearchIcon from '../../../../assets/StandardIcons/recent-search-icon.webp';



// ========================
// SearchSuggestionInstance – represents the '/search' Product page Search Suggestion component
// ========================
function SearchSuggestionInstance({
    suggestionQuery,            // String           – the search suggestion query text
    suggestionType,             // String (enum)    – the search suggestion type
    onSearchSuggestionClick,    // ()               – the Callback Function() triggered by component onClick()
}){

    // JSX Component
    return(
        <div className='SearchSuggestionInstance' onClick={() => onSearchSuggestionClick(suggestionQuery)}>

            {/* Condition #1: type === 'trending' */}
            { suggestionType === "trending" && <img src={trendingIcon} className='SearchSuggestionInstance-trending-icon' alt='A trending search suggestion.'/> }

            {/* Condition #2: type === 'recent' */}
            { suggestionType === "recent" && <img src={recentSearchIcon} className='SearchSuggestionInstance-recent-search-icon' alt="A recent search suggestion."/> }
            
            {/* Query */}
            {suggestionQuery}
        
        </div>
    );
};


// Export statement
export default SearchSuggestionInstance;